import React, { useContext, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./NewyearPurchaseModal.css";
import "../../../assets/css/modal.css";
import activityLogSubmission from "../../../helper/activitylog";
import analyticEvent from "../../../helper/gaEvent";
import xImg from "./x.png";
import styles from "./NewyearPurchaseModal.module.css";
import { convertToBengaliNumber } from "./helper";
import { Spinner } from "react-bootstrap";
import { dataContext } from "../../../App";
import { useNavigate } from "react-router-dom";
import { fetchOneTimeCheckoutUrlByEventId } from "../../../services";

const NewyearPurchaseModal = ({
  showNewyearPurchaseModal,
  setShowNewyearPurchaseModal,
}) => {
  const { token, playerData } = useContext(dataContext);
  const [isLoading, setIsLoading] = useState(false);
  const [notificationShown, setNotificationShown] = useState(false);
  const navigate = useNavigate();
  function hideModalOperation() {
    setShowNewyearPurchaseModal(false);
  }
  let totalTournamentRound =
    (playerData?.new_year_tournament?.day_spend || 0) * 2;
  let totalPlayedRound = (playerData?.new_year_tournament?.play_days || 0) * 2;

  function handleBuyNow() {
    setIsLoading(true);
    activityLogSubmission("newyear-purchase-button-click");
    fetchOneTimeCheckoutUrlByEventId(token, 150, "Tournament").then((res) => {
      window.location.replace(`${res?.bkashURL}`);
      setIsLoading(false);
    });
  }

  useEffect(() => {
    activityLogSubmission("newyear-purchase-modal");
    analyticEvent("newyear-purchase-modal", "newyear-purchase-modal-view");

    if (!notificationShown && Notification.permission === "granted") {
      navigator.serviceWorker.ready
        .then((registration) => {
          registration.showNotification("৫ টাকায় ২ রাউন্ড কিনুন!", {
            body: "আরও কুইজ খেলুন, লিডারবোর্ডে এগিয়ে যান!",
            icon: "https://ms.purplepatch.online/logo/quizard.png",
            requireInteraction: true,
            // actions: [
            //   {
            //     action: "redirect",
            //     title: "সাবস্ক্রাইব করুন",
            //     deepLink: "https://quizard.live/?page=subscription",
            //   },
            // ],
            data: {
              redirectPath: "https://quizard.live/?page=subscription",
            },
          });
          setNotificationShown(true);
        })
        .catch((error) => {
          console.error("Service Worker error:", error);
        });
    } else if (!notificationShown && Notification.permission !== "denied") {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          navigator.serviceWorker.ready
            .then((registration) => {
              registration.showNotification("৫ টাকায় ২ রাউন্ড কিনুন!", {
                body: "আরও কুইজ খেলুন, লিডারবোর্ডে এগিয়ে যান!",
                icon: "https://ms.purplepatch.online/logo/quizard.png",
                requireInteraction: true,
                // actions: [
                //   {
                //     action: "redirect",
                //     title: "সাবস্ক্রাইব করুন",
                //     deepLink: "https://quizard.live/?page=subscription",
                //   },
                // ],
                data: {
                  redirectPath: "https://quizard.live/?page=subscription",
                },
              });
              setNotificationShown(true);
            })
            .catch((error) => {
              console.error("Service Worker error:", error);
            });
        }
      });
    }
  }, []);

  return (
    <>
      <Modal
        show={showNewyearPurchaseModal}
        centered
        dialogClassName="modal-dialog"
        contentClassName="modalContentNewyearPurchaseModal"
        onHide={hideModalOperation}
      >
        <Modal.Body
          style={{
            // maxHeight: "65vh",
            overflow: "hidden",
            display: "block",
            overflowX: "hidden",
            padding: "6px 20px 0px",
          }}
        >
          <img
            src={xImg}
            alt="logo"
            className={styles.xImg}
            onClick={() => {
              hideModalOperation();
              navigate("../");
            }}
          />
          <section className={styles.div}>
            <div className={styles.div2}>
              <header className={styles.div3}>
                <h1 className={styles.span}>নিউ ইয়ার টুর্নামেন্ট ২০২৫</h1>
              </header>
              <p className={styles.div4}>
                <span>আমাদের নিউ ইয়ার টুর্নামেন্ট কমপ্লিট করেছে</span>{" "}
                <span className={styles.span2}>
                  {`${convertToBengaliNumber(totalTournamentRound)}`} রাউন্ড
                </span>
              </p>
              <img
                src="https://ms.quizard.live/bkash-quiz-banner/assets/gif/present.gif"
                alt="Present"
                className={styles.presentImage}
              />
              <div className={styles.div5}>
                <h2 className={styles.span3}>
                  এ পর্যন্ত আপনি খেলেছেন{" "}
                  {`${convertToBengaliNumber(totalPlayedRound)}`} রাউন্ড
                </h2>
                <p className={styles.span4}>
                  মাত্র ৫ টাকায় আরও ২ রাউন্ড খেলতে চান?
                </p>
              </div>
              <div className={styles.div6}>
                <button className={styles.div7} onClick={handleBuyNow}>
                  {isLoading ? (
                    <Spinner animation="border" variant="light" size="sm" />
                  ) : (
                    "২ রাউন্ড কিনুন এবং খেলুন – মাত্র ৫ টাকায়"
                  )}
                </button>
                <button className={styles.div8} onClick={() => navigate("../")}>
                  হোম
                </button>
              </div>
            </div>
          </section>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default NewyearPurchaseModal;
